import Header from './components/Header/Header.jsx'
import Spinner from './components/Spinner/Spinner.jsx'
import { useUserContext } from './context/UserContext.jsx'
import Router from './routes/index.jsx'
import DownloadQueueButton from './components/DownloadQueue/DownloadQueueButton.jsx'
import DownloadQueueDrawer from './components/DownloadQueue/DownloadQueueDrawer.jsx'

function App() {
  const { userLoading, isSaddlefitAdmin } = useUserContext()
  if (userLoading) return <Spinner />
  return (
    <>
      <Header />
      <Router />
      {isSaddlefitAdmin && (
        <>
          <DownloadQueueButton />
          <DownloadQueueDrawer />
        </>
      )}
    </>
  )
}

export default App
